module.exports = __webpack_public_path__ + "bo.svg?5f3fef091d666ea0ed093b1a427eac1f";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/bo.svg
// module id = 1266
// module chunks = 0